import camelCaseKeys from "camelcase-keys";
import { useState } from "react";
import { API_HOST } from "../config";
import { LoadingContainer } from "../containers/LoadingContainer";
import { UserListContainer } from "../containers/UserListContainer";
import axios from "../modules/axiosInstance";

export interface IModal {
  isOpen: boolean;
}

export interface IAdminRegisterModal {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export interface IProfileEditModal {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export interface ISearchBox {
  searchText: string;
  change: (text: string) => void;
  clear: () => void;
}

interface INavigatoinBar {
  adminRegisterModal: IAdminRegisterModal;
  profileEditModal: IProfileEditModal;
  searchBox: ISearchBox;
}

const useNavigationBar = () => {
  const [adminRegisterModalState, handleAdminRegisterModal] = useState<IModal>({
    isOpen: false
  });
  const [profileEditModalState, handleProfileEditModal] = useState<IModal>({
    isOpen: false
  });
  const [searchTextState, setSearchText] = useState<string>("");

  const matchUsers = UserListContainer.useContainer().changeMatchUsers;

  const adminRegisterModal = {
    isOpen: adminRegisterModalState.isOpen,
    open: () => {
      handleAdminRegisterModal({ isOpen: true });
    },
    close: () => handleAdminRegisterModal({ isOpen: false })
  };

  const profileEditModal = {
    isOpen: profileEditModalState.isOpen,
    open: () => {
      handleProfileEditModal({ isOpen: true });
    },
    close: () => handleProfileEditModal({ isOpen: false })
  };

  const loading = LoadingContainer.useContainer();

  const searchBox = {
    searchText: searchTextState,
    change: (text: string) => {
      setSearchText(text);
      if (text !== "") {
        const searchText = text;
        loading.start();
        const url = `${API_HOST}/api/users?query=${searchText}`;
        axios
          .get(url)
          .then(result => {
            const data: any = camelCaseKeys(result.data, { deep: true });
            matchUsers(data);
            loading.done();
          })
          .catch(e => {
            console.error(e);
          });
      }
    },
    clear: () => setSearchText("")
  };

  const NavigatoinBar: INavigatoinBar = {
    adminRegisterModal,
    profileEditModal,
    searchBox
  };

  return NavigatoinBar;
};

export default useNavigationBar;
